exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".InviteUserForm__form___315EE {\n  width: 500px;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: -0.4em;\n  color: #6b6767; }\n  .InviteUserForm__form___315EE > * {\n    margin-top: 0.4em;\n    margin-bottom: 0.4em; }\n  .InviteUserForm__form___315EE h2 {\n    font-weight: normal;\n    color: #6b6767; }\n  .InviteUserForm__form___315EE h2, .InviteUserForm__form___315EE .InviteUserForm__row___3bI4p {\n    padding: 0 1rem; }\n  .InviteUserForm__form___315EE .InviteUserForm__row___3bI4p {\n    display: inline-flex;\n    margin-top: 0.4em;\n    margin-bottom: 0.4em;\n    margin-left: -0.3em;\n    margin-right: -0.3em;\n    align-items: center;\n    justify-content: space-between; }\n    .InviteUserForm__form___315EE .InviteUserForm__row___3bI4p > * {\n      padding-left: 0.3em !important;\n      padding-right: 0.3em !important; }\n    .InviteUserForm__form___315EE .InviteUserForm__row___3bI4p .InviteUserForm__label___1xMDh {\n      white-space: nowrap; }\n", ""]);

// exports
exports.locals = {
	"form": "InviteUserForm__form___315EE",
	"row": "InviteUserForm__row___3bI4p",
	"label": "InviteUserForm__label___1xMDh"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Forms/InviteUserForm/InviteUserForm.scss
// module id = 726
// module chunks = 0